import { React } from "react";
import { Link } from 'react-router-dom';
import Card from "react-bootstrap/Card";
import Navbar from "../layout/Navbar";
import not from "./not.png";
import "./Dashboard.css";

const Dashboard = () => {
    return (
        <div className="Contaainer">
            <Navbar />
            <div>
                <div class="leftside">
                    <Card style={{ width: '18rem' }} className="mb-2">
                        <Card.Body>
                            <img src={not} class="rounded float-left"></img>
                            <Card.Text>Total News<br></br>10</Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            </div >
        </div >
    );
};

export default Dashboard;